import { cn } from '@brew/ui/cn'

const FOCUS =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background'

/**
 * Shared plan CTAs, in the Cursor-quiet pricing language: pill-shaped, flat
 * fills only. ONE solid featured action per surface (`bg-foreground`); every
 * alternative is a soft secondary fill or bare text. No gradients, no glass,
 * no glow, no outlines-for-decoration.
 */
export function pricingCtaClass(args: {
  tone: 'featured' | 'outline' | 'current' | 'ghost'
  size?: 'md' | 'sm'
  fullWidth?: boolean
}): string {
  const size = args.size ?? 'md'
  return cn(
    'flex cursor-pointer items-center justify-center rounded-lg font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-60',
    FOCUS,
    {
      'w-full': args.fullWidth !== false,
      'h-9 px-5 text-sm': size === 'md',
      'h-8 px-4 text-sm': size === 'sm',
      'bg-foreground text-background hover:bg-foreground/90':
        args.tone === 'featured',
      // Cursor's non-featured CTA: a soft filled pill, not a hairline outline.
      // Foreground-alpha (not a fixed grey) so the fill separates from the
      // tinted card surface in BOTH themes — bg-secondary matched the card's
      // luminance in light mode and the pill disappeared. The tone keeps its
      // historical name so call sites stay stable.
      'bg-foreground/5 text-foreground hover:bg-foreground/10':
        args.tone === 'outline' || args.tone === 'current',
      'bg-transparent text-muted-foreground hover:text-foreground':
        args.tone === 'ghost',
    }
  )
}
